import React from 'react';
import { FiAward, FiBookOpen } from 'react-icons/fi';
import SectionHead from '../ui/SectionHead';
import Reveal from '../ui/Reveal';
import { education, awards } from '../../data/profile';
import './Education.css';

export default function Education() {
  return (
    <section className="section section--tight education" id="education">
      <div className="container">
        <SectionHead
          index="07"
          label="Education & recognition"
          title={[{ text: 'Where it' }, { text: 'started.', em: true }]}
        />
        <div className="edu__grid">
          <Reveal className="card edu__card">
            <div className="edu__icon"><FiBookOpen /></div>
            <span className="mono">{education.period}</span>
            <h3 className="edu__degree">{education.degree}</h3>
            <p className="edu__school">
              {education.school} <span className="muted">&middot; {education.location}</span>
            </p>
            <p className="pill pill--tan edu__gpa">{education.gpa}</p>
            <ul className="edu__notes">
              {education.notes.map((n) => (
                <li key={n} className="small">{n}</li>
              ))}
            </ul>
          </Reveal>

          <Reveal className="awards" delay={0.1}>
            <div className="awards__head">
              <FiAward />
              <span className="mono">Awards</span>
            </div>
            <ul className="awards__list">
              {awards.map((a) => (
                <li key={a.title} className="awards__row">
                  <span className="mono awards__year">{a.year}</span>
                  <div>
                    <h4 className="awards__title">{a.title}</h4>
                    <p className="small">{a.detail}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
